import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25085029"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-container" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "批次ID", -1))
const _hoisted_5 = { class: "box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "所属企业", -1))
const _hoisted_7 = { class: "box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "预付卡名称", -1))
const _hoisted_9 = { class: "right" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "数量", -1))
const _hoisted_11 = { class: "num-red" }
const _hoisted_12 = { class: "num-red" }
const _hoisted_13 = { class: "num-red" }
const _hoisted_14 = { class: "num-red" }
const _hoisted_15 = { class: "autoList__content" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "卡号和密码是预付卡消费的唯一凭证，导出后请妥善保管，避免泄露造成不可挽回的损失。", -1))
const _hoisted_18 = { style: {"margin-bottom":"15px"} }
const _hoisted_19 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftOutlined = _resolveComponent("LeftOutlined")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_confirm_modal = _resolveComponent("confirm-modal")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer autoList" }, {
    title: _withCtx(() => [
      _createVNode(_component_router_link, { to: "/repaidCard/batchManage" }, {
        default: _withCtx(() => [
          _createVNode(_component_LeftOutlined)
        ]),
        _: 1
      }),
      _createTextVNode(" 预付卡批次详情 ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.batchId), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.enterpriseName), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.cardName), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", null, [
            _createElementVNode("div", null, _toDisplayString(_ctx.detailInfo.unbindCardNum + _ctx.detailInfo.hasBindCardNum) + " 张", 1),
            _createElementVNode("div", null, [
              _createTextVNode("未绑定: "),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.detailInfo.unbindCardNum), 1),
              _createTextVNode(" 张")
            ]),
            _createElementVNode("div", null, [
              _createTextVNode("已绑定: "),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.detailInfo.hasBindCardNum), 1),
              _createTextVNode(" 张")
            ]),
            _createElementVNode("div", null, [
              _createTextVNode("总面额: "),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.detailInfo.totalNominalAmount), 1),
              _createTextVNode(" 元")
            ]),
            _createElementVNode("div", null, [
              _createTextVNode("总余额: "),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.detailInfo.totalLeftAmount), 1),
              _createTextVNode(" 元")
            ])
          ])
        ]),
        _createVNode(_component_a_button, {
          type: "primary",
          style: {"margin-left":"10px"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onExport()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("导出卡密数据")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_a_form, {
          class: "fl-clean autoList__filterForm",
          form: _ctx.filterParams,
          layout: 'inline'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "预付卡ID" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.filterParams.cardNo,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterParams.cardNo) = $event)),
                  class: "filterInput",
                  "allow-clear": "",
                  placeholder: "批次ID"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "绑定员工" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.filterParams.bindMobile,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterParams.bindMobile) = $event)),
                  class: "filterInput",
                  "allow-clear": "",
                  placeholder: "分配员工"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "绑定时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_range_picker, {
                  value: _ctx.filterParams.bindTime,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterParams.bindTime) = $event)),
                  format: "YYYY-MM-DD",
                  placeholder: ['起始时间', '结束时间']
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "过期时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_range_picker, {
                  value: _ctx.filterParams.endTermOfValidity,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterParams.endTermOfValidity) = $event)),
                  format: "YYYY-MM-DD",
                  placeholder: ['起始时间', '结束时间']
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "绑定状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.filterParams.bindStatus,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterParams.bindStatus) = $event)),
                  style: {"width":"180px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("全部")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bindStatusList, (objVal, objKey) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: objKey,
                        value: objKey
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(objVal), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "卡状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.filterParams.cardStatus,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterParams.cardStatus) = $event)),
                  style: {"width":"180px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("全部")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardStatusList, (objVal, objKey) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: objKey,
                        value: objKey
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(objVal), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  ghost: "",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onRefreshTable()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["form"]),
        _createVNode(_component_app_table, {
          ref: "tableRef",
          size: "default",
          "row-key": "id",
          "show-pagination": true,
          columns: _ctx.tableColumns,
          data: _ctx.loadTableData,
          scroll: { x: true }
        }, {
          action: _withCtx(({ record }) => [
            ((record.cardStatus === 'effective' && !record.bindMobile))
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (_ctx.onDistribute(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("绑定")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data"])
      ]),
      (_ctx.showConfirmModal)
        ? (_openBlock(), _createBlock(_component_confirm_modal, {
            key: 0,
            "confirm-info": _ctx.confirmInfo,
            onClose: _ctx.closeConfirmModal
          }, null, 8, ["confirm-info", "onClose"]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_modal, {
        visible: _ctx.confirmVisible,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.confirmVisible) = $event)),
        title: "导出卡密",
        "confirm-loading": _ctx.exporting,
        "ok-text": "导出",
        onOk: _ctx.makePhoneValid
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_descriptions, {
            title: "",
            column: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_descriptions_item, { label: "所属企业" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailInfo.enterpriseName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "预付卡名称" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailInfo.cardName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "面额" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailInfo.totalNominalAmount), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "数量" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(( _ctx.detailInfo.unbindCardNum + _ctx.detailInfo.hasBindCardNum )), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_17,
          _createElementVNode("p", null, "导出后可通过以下页面绑定、使用：" + _toDisplayString(_ctx.h5Url), 1)
        ]),
        _: 1
      }, 8, ["visible", "confirm-loading", "onOk"]),
      _createVNode(_component_a_modal, {
        visible: _ctx.phoneValidVisible,
        "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.phoneValidVisible) = $event)),
        title: "安全验证",
        onOk: _ctx.onConfirmExport,
        onCancel: _ctx.cancel
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_18, [
            _createTextVNode("验证码已发送到手机" + _toDisplayString(_ctx.userMobile) + "【", 1),
            (_ctx.countDownTime > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.countDownTime) + "s", 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: "resend",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.makePhoneValid && _ctx.makePhoneValid(...args)))
            }, "重新发送"),
            _createTextVNode("】")
          ]),
          _createVNode(_component_a_input, {
            value: _ctx.validCode,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.validCode) = $event)),
            placeholder: "请输入验证码"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["visible", "onOk", "onCancel"])
    ]),
    _: 1
  }))
}